import React from 'react';
import {
  ApModal,
  ApButtonGroup,
  ApButtonSecondary,
  ApButtonMain,
} from '@alixpartners/ui-components';

export const ConfirmDownloadDialog = ({
  confirmText,
  isConfirmDisabled,
  isOpen,
  title,
  message,
  onConfirm,
  onClose,
}: {
  confirmText: string;
  isConfirmDisabled: boolean;
  isOpen: boolean;
  title: string;
  message: React.ReactNode;
  onConfirm: () => void;
  onClose: () => void;
}) => (
  <ApModal
    isDismissible
    isOpen={isOpen}
    hasClosed={onClose}
    header={title}
    footer={({ handleClose }) => (
      <ApButtonGroup justifyContent="flex-end">
        <ApButtonSecondary onClick={() => handleClose && handleClose()}>
          Cancel
        </ApButtonSecondary>
        <ApButtonMain disabled={isConfirmDisabled} onClick={onConfirm}>
          {confirmText}
        </ApButtonMain>
      </ApButtonGroup>
    )}
  >
    <div>{message}</div>
  </ApModal>
);

export default ConfirmDownloadDialog;
